export default {
  "formstepform.basic.title": "基础表单",
  "formstepform.basic.description": "表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。",
  "formstepform.email.required": "请输入邮箱地址！",
  "formstepform.email.wrong-format": "邮箱地址格式错误！",
  "formstepform.userName.required": "请输入用户名!",
  "formstepform.password.required": "请输入密码！",
  "formstepform.password.twice": "两次输入的密码不匹配!",
  "formstepform.strength.msg": "请至少输入 6 个字符。请不要使用容易被猜到的密码。",
  "formstepform.strength.strong": "强度：强",
  "formstepform.strength.medium": "强度：中",
  "formstepform.strength.short": "强度：太短",
  "formstepform.confirm-password.required": "请确认密码！",
  "formstepform.phone-number.required": "请输入手机号！",
  "formstepform.phone-number.wrong-format": "手机号格式错误！",
  "formstepform.verification-code.required": "请输入验证码！",
  "formstepform.title.required": "请输入标题",
  "formstepform.date.required": "请选择起止日期",
  "formstepform.goal.required": "请输入目标描述",
  "formstepform.standard.required": "请输入衡量标准",
  "formstepform.form.get-captcha": "获取验证码",
  "formstepform.captcha.second": "秒",
  "formstepform.form.optional": "（选填）",
  "formstepform.form.submit": "提交",
  "formstepform.form.save": "保存",
  "formstepform.email.placeholder": "邮箱",
  "formstepform.password.placeholder": "至少6位密码，区分大小写",
  "formstepform.confirm-password.placeholder": "确认密码",
  "formstepform.phone-number.placeholder": "手机号",
  "formstepform.verification-code.placeholder": "验证码",
  "formstepform.title.label": "标题",
  "formstepform.title.placeholder": "给目标起个名字",
  "formstepform.date.label": "起止日期",
  "formstepform.placeholder.start": "开始日期",
  "formstepform.placeholder.end": "结束日期",
  "formstepform.goal.label": "目标描述",
  "formstepform.goal.placeholder": "请输入你的阶段性工作目标",
  "formstepform.standard.label": "衡量标准",
  "formstepform.standard.placeholder": "请输入衡量标准",
  "formstepform.client.label": "客户",
  "formstepform.label.tooltip": "目标的服务对象",
  "formstepform.client.placeholder": "请描述你服务的客户，内部客户直接 @姓名／工号",
  "formstepform.invites.label": "邀评人",
  "formstepform.invites.placeholder": "请直接 @姓名／工号，最多可邀请 5 人",
  "formstepform.weight.label": "权重",
  "formstepform.weight.placeholder": "请输入",
  "formstepform.public.label": "目标公开",
  "formstepform.label.help": "客户、邀评人默认被分享",
  "formstepform.radio.public": "公开",
  "formstepform.radio.partially-public": "部分公开",
  "formstepform.radio.private": "不公开",
  "formstepform.publicUsers.placeholder": "公开给",
  "formstepform.option.A": "同事甲",
  "formstepform.option.B": "同事乙",
  "formstepform.option.C": "同事丙",
};
